import React, { useEffect, useState, useContext } from "react";
import styled from "styled-components";

import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

import ProfileButtonComponent from './ProfileButtonComponent';
import PaymentDetailsComponent from './PaymentDetailsComponent';

import logo from "../../assets/cat_logo.svg";

import { logout} from '../../utils/loginHelper';
import CancelIcon from "../../assets/cancel_white_icon.svg";
import hamburger from '../../assets/hamburger.svg';
import userProfile from '../../assets/user_circle_outline.svg';
import userSignOut from '../../assets/door_arrow_right_outline.svg';

const Mobile = styled.div`
  display: none;
  background: #000;
  padding: 26px;
  padding-bottom: 0px;
  
  @media only screen and (max-device-width: 480px) {
  display: flex;
  /* height: 96vh; */
  flex-direction: row;
  }
`;

const Nav = styled.div`
  /* background-image: url(banner); */
  padding: 12px 120px;
  padding-bottom: 0px;
  flex-direction: column;
  justify-content: space-between;
  display: none;
  @media (min-device-width: 481px) {
  display: flex;
  }
`;


const HorizontalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;


const UsernameLink = styled.a`
  font-family: 'IBM Plex Mono';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  color: #FFFFFF;
`
const Username = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 90.1%;
  display: flex;
  align-items: center;
  text-transform: uppercase;
`;


const Text = styled.a`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #FFFFFF;
  margin-left: 13px;
`;

const OutLinkText = styled.a`
  font-family: 'IBM Plex Mono';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #FFFFFF;
  margin-top:36px;
`

export default function NFTNavDesktop(props:any){
    const history = useHistory();
        
    return (
        <>
            <Mobile style={{justifyContent: 'space-between'}}>
                <HorizontalWrapper>
                    <a href="https://glip.gg/" >
                        <img style={{width: 36, height: 36}} src={logo} />
                    </a>
                </HorizontalWrapper>
                <HorizontalWrapper>
                    <ProfileButtonComponent
                        connected={props.connected}
                        user={props.user}
                        setShowModal={props.setShowModal}
                    >
                    </ProfileButtonComponent>
                    <img style={{
                        marginLeft: 12,
                        position: 'relative'}}
                         onClick={() => props.setMobileNavModal(true)}
                         src={hamburger} />
                </HorizontalWrapper>
            </Mobile>
            {(props.mobileNavModal) && (
                <div onClick={() => {
                    props.setShowModal(false);
                    props.setMobileNavModal(false);
                }}
		     style={{
                         position: "fixed",
		         top: 0,
		         bottom: 0,
		         left: 0,
		         right: 0,
		         background: "black",
                         zIndex: 2001,
		     }}>
                    <div style={{position: 'relative',
                                 zIndex: 201, display: 'flex',
                                 flexDirection:'column',
                                 padding:26,
                                 paddingBottom:0,
                    }}>
                        <div style={{
                            display:'flex',
                            justifyContent:'space-between',
                            alignItems:'center',
                            marginBottom: 29
                        }}>
                            <img src={logo} style={{
                                width:36,
                                height:36
                            }} />
                            <img src={CancelIcon} style={{
                                width:16,
                                height:16
                            }}/>
                        </div>
                        <div style={{
                            display:'flex',
                            paddingBottom:16,
                            flexDirection:'column',
                            borderBottom: '1px solid rgb(255, 255, 255, 0.1)'
                        }}>
                            <Username>{props.user.username}</Username>
                            <PaymentDetailsComponent
                                openAddPaymentsDiv={props.openAddPaymentsDiv}
                            >
                            </PaymentDetailsComponent>
                            {(props.connected) && (
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginTop: 40
                                }}>
                                    <div style={{display: 'flex'}}>
                                        <img src={userProfile} style={{
                                            width:23,
                                            height:23
                                        }} />
			                <Text
                                            onClick={() => {
                                                window.analytics.track('mynfts_clicked', {
                                                    type: 'web',
                                                    from: 'navbar'
                                                });
                                                history.push(`/address/${props.user.username}`)
                                            }}
                                        >
                                            My Profile
                                        </Text>
                                    </div>
                                    <div style={{
			                display: 'flex',
			                justifyContent: 'flex-start',
			                marginTop: 25, marginBottom: 25,
                                        cursor:'pointer'
			            }}
                                         onClick={()=>{logout()}}
                                    >
			                <img src={userSignOut} />
			                <Text>Sign out</Text>
			            </div>
                                </div>
                            )}
                        </div>
                        <div style={{display:'flex',
                                     flexDirection:'column'}}>
                            <OutLinkText
	                        href={"https://glip.gg/"}>
	                        FOR CREATORS
                            </OutLinkText>
	                    <OutLinkText
	                        target="_blank"
	                        href={"https://discord.gg/3KqyT6Js7r"}
	                    >DISCORD</OutLinkText>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
